import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import {
  deleteItemCollection,
  editCollection,
} from "../../../../api/ApiCollection";
import { TblCollection } from "../../../../model/TblComboSetCollection";
import Repository from "../../../../_base/helper/HttpHelper";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";

const DeleteViewFrame = ({
  itemCode,
  onSearch,
  formData,
  idBST,
}: DeleteProduct) => {
  const handleDeleteProductAds = async () => {
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    if (itemCode && itemCode?.length > 0) {
      const res = await repository.post(`/TblKhung/remove-products`, {
        khungId: idBST,
        productCodes: itemCode,
      });
      modals.closeAll();
      if (res && res.success) {
        NotificationExtension.Success(
          "Xóa sản phẩm khỏi bộ sưu tập thành công !"
        );
      } else {
        NotificationExtension.Fails("Xóa sản phẩm khỏi bộ sưu tập thất bại !");
      }
      onSearch && onSearch();
    }
  };

  return (
    <div>
      <Text size="24px" mt={10} mb={10}>
        Bạn có chắc chắn muốn xóa các sản phẩm này khỏi bộ sưu tập?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="#3598dc"
          onClick={handleDeleteProductAds}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
        <Button
          type="button"
          color="#3598dc"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
      </Group>
    </div>
  );
};

type DeleteProduct = {
  itemCode?: string[];
  onSearch?: () => void;
  formData?: TblCollection;
  idBST?: number; //id bộ sưu tập
};

export default DeleteViewFrame;
